/**
 * What the coach is agreeing to, in one plain sentence, just above Create Account.
 *
 * `trialDays` is null from an API older than the trial, so the sentence then names only the price.
 */
export const SignupPriceConfirmation = ({
  price,
  trialDays,
}: {
  /** Already formatted, for example "$3,500". */
  price: string;
  trialDays: number | null;
}) => (
  <p className="signup-price-confirmation" data-testid="signup-price-confirmation">
    {trialDays !== null
      ? `Start with a ${trialDays}-day free trial. No card needed. After that, your program is ${price} per year.`
      : `Your program will be billed ${price} per year.`}
  </p>
);
